import './styles/finances.css'

import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import BalanceModal from '../components/balance-modal'
import { IoIosClose } from "react-icons/io"
import Confirm from '../components/confirm'

//Extras
import { fontType, main } from "../assets/extras"
import { decomposeDate, formatedNumber, getCurrentDate, } from '../assets/validator'
import { collection, deleteDoc, doc, getDocs, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import * as XLSX from "xlsx"

const Finances = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        data: {},
        newData: {
            concepto: "",
            cantidad: 0
        },
        categoriaIngreso: "",
        categoriaEgreso: "",
        newFinances: false,
        totalIngresos: 0,
        totalEgresos: 0,
        sumaPorDias: [],
        selectedDate: getCurrentDate(),
        showBalance: false,
    })
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Formatear fecha
    function formatDate(d) {
        let currDate = d.split("-")

        return currDate[0] + "-" +
            (currDate[1].length == 1 ? "0" + currDate[1] : currDate[1]) + "-" +
            (currDate[2].length == 1 ? "0" + currDate[2] : currDate[2])
    }

    //Funcion que obtiene los datos de la finanzas
    const getFinances = async (d = variables.selectedDate) => {
        const newDate = formatDate(d)
        await getDocs(query(collection(doc(db, ref), "Finanzas"), where("fecha", "==", newDate))).then(r => {
            var aux = {}
            //Sacamos el total de ingresos y egresos
            let totalIngresos = 0
            let totalEgresos = 0

            if (r.docs.length > 0) {
                r.docs.map((v, i) => {
                    aux = {
                        id: v.id,
                        ...v.data()
                    }

                    v.data().ingresos.forEach(item => {
                        totalIngresos += parseFloat(item.cantidad)
                    });
                    v.data().egresos.forEach(item => {
                        totalEgresos += parseFloat(item.cantidad)
                    });

                })
            } else {
                aux = {
                    fecha: getCurrentDate(),
                    ingresos: [],
                    egresos: []
                }

                setVariables(prev => ({
                    ...prev,
                    newFinances: true,
                }))
            }

            setVariables(prev => ({
                ...prev,
                data: aux,
                totalIngresos,
                totalEgresos,
                loading: false
            }))
        }).catch(e => {
            console.log(e)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Funcion que obtiene el balance general
    const onGetBalance = async () => {
        const input = window.prompt("Ingresa la contraseña: ")?.toString()

        if (input == "password1234") {
            setVariables(prev => ({
                ...prev,
                loading: true
            }))

            setTimeout(async () => {
                await getDocs(query(collection(doc(db, ref), "Finanzas"))).then(r => {

                    let totalIngresos = 0
                    let totalEgresos = 0

                    var arregloDias = []

                    //Hacemos la suma primero por dias
                    r.docs.map((v, i) => {
                        arregloDias.push({
                            fecha: v.id,
                            ingresos: v.data().ingresos,
                            egresos: v.data().egresos,
                            totalIngresos: v.data().ingresos.reduce((previous, current) => previous + parseInt(current.cantidad), 0),
                            totalEgresos: v.data().egresos.reduce((previous, current) => previous + parseInt(current.cantidad), 0)
                        })
                    })

                    //Ahora hacemos la suma general del toatl de ingresos y de egresos
                    arregloDias.map((v, i) => {
                        totalIngresos += parseInt(v.totalIngresos)
                        totalEgresos += parseInt(v.totalEgresos)
                    })

                    setVariables(prev => ({
                        ...prev,
                        totalIngresos,
                        totalEgresos,
                        sumaPorDias: arregloDias,
                        loading: false,
                        showBalance: true
                    }))
                }).catch(e => {
                    console.log(e)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    showMessage("Error al obtener balance", "error")
                })
            }, 10)
        } else {
            showMessage("Contraseña incorrecta", "error")
        }

    }

    //Funcion que genera el XLSX
    async function generateXLSX() {

        var data = []

        //Primero recorremos todas las fechas
        variables.sumaPorDias.map((dias) => {
            dias.ingresos.map((ingreso) => {
                data.push({
                    Fecha: decomposeDate(dias.fecha),
                    Concepto: ingreso.concepto,
                    Categoria: ingreso.categoria ?? "Sin categoria",
                    Cantidad: ingreso.cantidad
                })
            })
            dias.egresos.map((egreso) => {
                data.push({
                    Fecha: decomposeDate(dias.fecha),
                    Concepto: egreso.concepto,
                    Categoria: egreso.categoria ?? "Sin categoria",
                    Cantidad: egreso.cantidad*-1
                })
            })
            data.push({
                Categoria: "Total",
                Cantidad: dias.totalIngresos-dias.totalEgresos
            })
            data.push({})
        })

        // Crear la hoja de cálculo
        const worksheet = XLSX.utils.json_to_sheet(data)

        // Crear el libro de trabajo
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "Datos")

        // Generar archivo Excel
        XLSX.writeFile(workbook, "Balance a " + decomposeDate(getCurrentDate()) + ".xlsx")

        setVariables(prev => ({
            ...prev,
            showBalance: false
        }))

        showMessage("XLSX generado correctamente", "success")

        setConfirm(prev => ({
            show: true,
            title: "¿Deseas eliminar los registros?",
            text: "Al eliminar los registros estos quedan almacenados solo en el XSLX"
        }))
    }

    //Eliminar registros del balance
    async function deleteBalance(){
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        setTimeout(async () => {
            variables.sumaPorDias.map(async (v, i) => {
                await deleteDoc(doc(doc(db, ref), "Finanzas", v.fecha)).catch(e => {
                    console.log(e.code)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("Error al eliminar registros", "error")
                    }, 10)
                    return
                })
            })

            setVariables(prev => ({
                ...prev,
                loading: false
            }))

            setTimeout(() => {
                setVariables(prev => ({
                    ...prev,
                    sumaPorDias: [],
                    totalEgresos: 0,
                    totalIngresos: 0,
                    data: {
                        ...prev.data,
                        ingresos: [],
                        egresos: []
                    },
                    newFinances: true
                }))
                showMessage("Registros eliminados", "success")
            }, 10)

        }, 500)
    }

    //Funcion que elimina un ingreso
    const deleteIngreso = async (index) => {
        const newArray = [...variables.data.ingresos]
        const item = newArray.splice(index, 1)

        await updateDoc(doc(doc(db, ref), "Finanzas", variables.selectedDate), {
            ingresos: newArray
        }).then(r => {
            variables.totalIngresos -= variables.data.ingresos[index].cantidad
            setVariables(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    ingresos: newArray
                }
            }))

            showMessage("Item eliminado correctamente", "success")
        }).catch(e => {
            console.log(e)
            newArray.push(item)
            setVariables(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    ingresos: newArray
                }
            }))
            showMessage("Error al eliminar item", "error")
        })
    }

    //Funcion que elimina un egreso
    const deleteEgreso = async (index) => {
        const newArray = [...variables.data.egresos]
        const item = newArray.splice(index, 1)

        await updateDoc(doc(doc(db, ref), "Finanzas", variables.selectedDate), {
            egresos: newArray
        }).then(r => {
            variables.totalEgresos -= variables.data.egresos[index].cantidad
            setVariables(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    egresos: newArray
                }
            }))

            showMessage("Item eliminado correctamente", "success")
        }).catch(e => {
            newArray.push(item)
            setVariables(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    egresos: newArray
                }
            }))
            showMessage("Error al eliminar item", "error")
        })
    }

    //Funcion que agrega un ingreso
    const addIngreso = async () => {
        if (isNaN(variables.newData.cantidad) && variables.newData.cantidad != "") {
            showMessage("Debes ingresar una cantidad valida", "warning")
            return
        }
        if (!variables.categoriaIngreso) {
            showMessage("Debes seleccionar una categoria", "warning")
            return
        }

        if (variables.newData.concepto && variables.newData.cantidad > 0) {

            if (variables.newFinances == true) {
                await setDoc(doc(doc(db, ref), "Finanzas", variables.selectedDate), {
                    ingresos: [...variables.data.ingresos, { ...variables.newData, categoria: variables.categoriaIngreso }],
                    egresos: [],
                    fecha: variables.selectedDate
                }).then(r => {
                    variables.data.ingresos = [...variables.data.ingresos, { ...variables.newData, categoria: variables.categoriaIngreso }]
                    setVariables(prev => ({
                        ...prev,
                        totalIngresos: prev.totalIngresos + parseFloat(variables.newData.cantidad),
                        newFinances: false,
                        newData: {
                            concepto: "",
                            cantidad: 0
                        },
                        categoriaIngreso: ""
                    }))
                    showMessage("Ingreso agregado", "success")
                }).catch(e => {
                    console.log(e)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    showMessage("Error de conexion", "error")
                })
            } else {
                await updateDoc(doc(doc(db, ref), "Finanzas", variables.selectedDate), {
                    ingresos: [...variables.data.ingresos, { ...variables.newData, categoria: variables.categoriaIngreso }],
                }).then(r => {
                    variables.data.ingresos = [...variables.data.ingresos, { ...variables.newData, categoria: variables.categoriaIngreso }]
                    setVariables(prev => ({
                        ...prev,
                        totalIngresos: prev.totalIngresos + parseFloat(variables.newData.cantidad),
                        newData: {
                            concepto: "",
                            cantidad: 0
                        },
                        categoriaIngreso: ""
                    }))
                    showMessage("Ingreso agregado", "success")
                }).catch(e => {
                    console.log(e)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    showMessage("Error de conexion", "error")
                })
            }


        } else {
            showMessage("Debes completar todos los campos", "warning")
        }
    }

    //Funcion que agrega un egreso
    const addEgreso = async () => {
        if (isNaN(variables.newData.cantidad) && variables.newData.cantidad != "") {
            showMessage("Debes ingresar una cantidad valida", "warning")
            return
        }
        if (!variables.categoriaEgreso) {
            showMessage("Debes seleccionar una categoria", "warning")
            return
        }
        if (variables.newData.concepto && variables.newData.cantidad > 0) {

            if (variables.newFinances == true) {
                await setDoc(doc(doc(db, ref), "Finanzas", variables.selectedDate), {
                    egresos: [...variables.data.egresos, { ...variables.newData, categoria: variables.categoriaEgreso }],
                    ingresos: [],
                    fecha: variables.selectedDate
                }).then(r => {
                    variables.data.egresos = [...variables.data.egresos, { ...variables.newData, categoria: variables.categoriaEgreso }]
                    setVariables(prev => ({
                        ...prev,
                        totalEgresos: prev.totalEgresos + parseFloat(variables.newData.cantidad),
                        newFinances: false,
                        newData: {
                            concepto: "",
                            cantidad: 0
                        },
                        categoriaEgreso: ""
                    }))
                    showMessage("Egreso agregado", "success")
                }).catch(e => {
                    console.log(e)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    showMessage("Error de conexion", "error")
                })
            } else {
                await updateDoc(doc(doc(db, ref), "Finanzas", variables.selectedDate), {
                    egresos: [...variables.data.egresos, { ...variables.newData, categoria: variables.categoriaEgreso }],
                }).then(r => {
                    variables.data.egresos = [...variables.data.egresos, { ...variables.newData, categoria: variables.categoriaEgreso }]
                    setVariables(prev => ({
                        ...prev,
                        totalEgresos: prev.totalEgresos + parseFloat(variables.newData.cantidad),
                        newData: {
                            concepto: "",
                            cantidad: 0
                        },
                        categoriaEgreso: ""
                    }))
                    showMessage("Egreso agregado", "success")
                }).catch(e => {
                    console.log(e)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    showMessage("Error de conexion", "error")
                })
            }


        } else {
            showMessage("Debes completar todos los campos", "warning")
        }
    }

    useEffect(() => {
        getFinances()
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div className='mainFinances'>

                <Snack />

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                    onHandle={deleteBalance}
                />

                <BalanceModal
                    variables={variables}
                    setVariables={setVariables}
                    generateXLSX={generateXLSX}
                />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>FINANZAS</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -41,
                    marginBottom: 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                        localStorage.getItem("authToken") ?
                            JSON.parse(localStorage.getItem("authToken")).nombre_academia
                            : ""
                    }</h2>

                <div style={{
                    padding: 20
                }}>
                    <p style={{
                        fontFamily: fontType.title,
                        fontSize: 16,
                        textAlign: "center"
                    }}>Seleccionar fecha</p>
                    <input
                        type='date'
                        style={{
                            padding: 8,
                            border: "2px solid #ccc",
                            borderRadius: 10
                        }}
                        value={variables.selectedDate}
                        onChange={e => {
                            setVariables(prev => ({
                                ...prev,
                                selectedDate: e.target.value,
                                loading: true
                            }))

                            setTimeout(() => {
                                getFinances(e.target.value)
                            }, 10)
                        }}
                    />
                </div>

                <h3 style={{
                    fontFamily: fontType.text,
                    fontWeight: "bold",
                    marginBottom: 10
                }}>{decomposeDate(variables.selectedDate)}</h3>

                <div className='finance-add'>
                    <input
                        style={{
                            fontFamily: fontType.text
                        }}
                        placeholder='Concepto'
                        maxLength={30}
                        value={variables.newData.concepto}
                        onChange={e => {
                            const t = e.target.value
                            setVariables(prev => ({
                                ...prev,
                                newData: {
                                    ...prev.newData,
                                    concepto: t
                                }
                            }))
                        }}
                    />
                    <input
                        style={{
                            fontFamily: fontType.text
                        }}
                        placeholder='Cantidad'
                        type='number'
                        value={variables.newData.cantidad}
                        onChange={e => {
                            if (isNaN(e.target.value) && e.target.value != "") {
                                showMessage("Debes ingresar una cantidad valida", "error")
                                return
                            }

                            const t = parseFloat(e.target.value)
                            setVariables(prev => ({
                                ...prev,
                                newData: {
                                    ...prev.newData,
                                    cantidad: t
                                }
                            }))
                        }}
                    />
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        marginBottom: 10,
                        width: "100%"
                    }}>
                        <div className='custom-select' style={{
                            flex: 1
                        }}>
                            <select id="Rama" name="Rama" style={{
                                fontFamily: fontType.text,
                                width: "100%"
                            }}
                                value={variables.categoriaIngreso}
                                onChange={e => {
                                    setVariables(prev => ({
                                        ...prev,
                                        categoriaIngreso: e.target.value
                                    }))
                                }}
                            >
                                <option value="">Categoria de ingreso</option>
                                <option value="Inscripcion">Inscripcion</option>
                                <option value="Mensualidad">Mensualidad</option>
                                <option value="Renta cancha">Renta cancha</option>
                                <option value="Torneos">Torneos</option>
                                <option value="Venta de...">Venta de...</option>
                                <option value="Patrocinio">Patrocinio</option>
                                <option value="Otros">Otros</option>
                            </select>
                        </div>
                        <div className='custom-select' style={{
                            flex: 1
                        }}>
                            <select id="Rama" name="Rama" style={{
                                fontFamily: fontType.text,
                                width: "100%"
                            }}
                                value={variables.categoriaEgreso}
                                onChange={e => {
                                    setVariables(prev => ({
                                        ...prev,
                                        categoriaEgreso: e.target.value
                                    }))
                                }}
                            >
                                <option value="">Categoria de egreso</option>
                                <option value="Canchas">Canchas</option>
                                <option value="Pelotas">Pelotas</option>
                                <option value="Luz">Luz</option>
                                <option value="Sueldo">Sueldo</option>
                                <option value="Comisiones">Comisiones</option>
                                <option value="Mantenimiento">Mantenimiento</option>
                                <option value="Oficina">Oficina</option>
                                <option value="Aseo">Aseo</option>
                                <option value="Insumos">Insumos</option>
                                <option value="Otros">Otros</option>
                            </select>
                        </div>
                    </div>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        gap: 10
                    }}>
                        <button style={{
                            width: 150,
                            padding: 10,
                            fontFamily: fontType.title,
                            border: "none",
                            borderRadius: 10,
                            backgroundColor: main,
                            color: "white",
                            cursor: "pointer"
                        }}
                            onClick={addIngreso}
                        >
                            AGREGAR INGRESO
                        </button>

                        <button style={{
                            width: 150,
                            padding: 10,
                            fontFamily: fontType.title,
                            border: "none",
                            borderRadius: 10,
                            backgroundColor: "#000",
                            color: "white",
                            cursor: "pointer"
                        }}
                            onClick={onGetBalance}
                        >
                            VER BALANCE
                        </button>

                        <button style={{
                            width: 150,
                            padding: 10,
                            fontFamily: fontType.title,
                            border: "none",
                            borderRadius: 10,
                            backgroundColor: "#500",
                            color: "white",
                            cursor: "pointer"
                        }}
                            onClick={addEgreso}
                        >
                            AGREGAR EGRESO
                        </button>

                    </div>
                </div>

                <div className='cont-table'>
                    <div className="finance-column ingresos">
                        <h2 style={{
                            fontFamily: fontType.title
                        }}>Ingresos ${formatedNumber(variables.totalIngresos)}</h2>

                        {
                            variables.data ?
                                variables.data.ingresos.map((v, i) => {
                                    return (
                                        <span className='finance-item'>
                                            <IoIosClose
                                                size={30}
                                                color='#800'
                                                style={{
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    top: "20%",
                                                    right: 10
                                                }}
                                                onClick={() => deleteIngreso(i)}
                                            />
                                            <div
                                                style={{
                                                    fontFamily: fontType.text
                                                }}
                                            > ▲ {v.concepto} - ${formatedNumber(v.cantidad)} </div>
                                            <div
                                                style={{
                                                    fontFamily: fontType.text,
                                                    textDecoration: "underline"
                                                }}
                                            > {
                                                    v.categoria ? v.categoria : "Sin categoria"
                                                } </div>
                                        </span>
                                    )
                                })
                                : null
                        }
                    </div>

                    <div className="finance-column egresos">
                        <h2 style={{
                            fontFamily: fontType.title
                        }}>Egresos ${formatedNumber(variables.totalEgresos)}</h2>
                        {
                            variables.data ?
                                variables.data.egresos.map((v, i) => {
                                    return (
                                        <span className='finance-item'>
                                            <IoIosClose
                                                size={30}
                                                color='#800'
                                                style={{
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    top: "20%",
                                                    right: 10
                                                }}
                                                onClick={() => deleteEgreso(i)}
                                            />
                                            <div
                                                style={{
                                                    fontFamily: fontType.text
                                                }}
                                            > ▲ {v.concepto} - ${formatedNumber(v.cantidad)} </div>
                                            <div
                                                style={{
                                                    fontFamily: fontType.text,
                                                    textDecoration: "underline"
                                                }}
                                            > {
                                                    v.categoria ? v.categoria : "Sin categoria"
                                                } </div>
                                        </span>
                                    )
                                })
                                : null
                        }
                    </div>
                </div>


            </div>
        )
}

export default Finances